//CSS
import "../../Components/Page/Page.css";
import engine from "../../Images/OurStory/Wankel.png";

import tradeShow from "../../Images/TradeShow/TradeShowGeneral.jpg";
import OurBooth from "../../Images/TradeShow/OurBooth.jpeg"

import Flat6 from "../../Images/TradeShow/Flat6.png";
import POC1 from "../../Images/TradeShow/POC1-v103.jpg";
import POC2 from "../../Images/TradeShow/IMG_6451.jpeg";
import Badger from "../../Images/TradeShow/IMG_6455.jpeg";
import ESPECSC from "../../Images/TradeShow/ESPEC_SC.png";

//React
import React from "react";
import SecHeader from "../../Components/SecHeader/SecHeader";
import SubSection from "../../Components/Section/SubSection";
import ImageComp from "../../Components/ImageContainer/ImageComp";
import PipeDriveEmbed from "../../Pages/PipeDrive/PipeDriveEmbed";
import { Link } from "react-router-dom";

const TorontoContent: React.FC = () => {
    return (
        <div id="Goals" className="sectionContainer">
            <SecHeader title="Our Show" />

            <SubSection>
                <ImageComp imageSource={OurBooth} width={"Max(25vw, 15rem)"} />
                <div className="description-container">
                    <p>
                        This succesfull tradeShow conducted, with Pro-Pak APU Systems at the Truck World Trade
                        Show in Toronto, showcased the world’s first completely balanced 2-cylinder
                        engine. In addition we also displayed our latest bench test hardware, including proof of concept
                        assemblies and our first test engine. We showed and demod for the first time our
                        <Link to="../user-login"> ESPEC™ </Link>
                        software. We enjoyed our deep dives into ELF-Tech, the discovery of
                        where we are headed, and finding new partners to be a part of our journey.
                    </p>{" "}
                    {/* <p>
                        Come visit our booth 2267 in hall 2, with Pro-Pak APU Systems at the Truck World Trade 
                        Show in Toronto. We will be unveiling the world’s first completely balanced 2-cylinder 
                        engine as we showcase our latest bench test hardware, including proof of concept 
                        assemblies and our first test engine. We will also show and demo for the first time our 
                        ESPEC™ software. Find one of our team members to dive deeper into ELF-Tech, discover 
                        where we are headed, and find out how you can be a part of our journey.
                    </p>{" "} */}
                </div>
            </SubSection>
            <SecHeader title="View Our Engine Variations" />
            {/* <SubSection isSplit={false}>
                <div className="description-container">
                    <p>
                        Come take a look at any one of our engine assemblies as proof of our inovative concepts, the speed
                        of our development, and what the future of engine design will look like.
                    </p>{" "}
                </div>
            </SubSection> */}
            <SubSection>
                <ImageComp imageSource={Flat6} width={"Max(25vw, 15rem)"} />
                <div className="description-container">
                    <h2>ELF-Tech’s Boxer-6 shown first in 2025</h2>
                    <p>
                        A compact smooth and efficient design in our multi-crank family.

                    </p>{" "}
                </div>
            </SubSection>
            <SubSection>

                <div className="description-container">
                    <h2>Proof of Concept Assembly V001</h2>
                    <p>
                        From off-the-shelf parts, this proof-of-concept assembly version 001 employs our internals v001a design
                        and shows one of our self-balancing internals geometries with stabilized pistons. When bench tested it
                        had almost no vibration.
                    </p>{" "}
                </div>
                <ImageComp imageSource={POC1} width={"Max(25vw, 15rem)"} />
            </SubSection>
            <SubSection>
                <ImageComp imageSource={POC2} width={"Max(25vw, 15rem)"} />
                <div className="description-container">
                    <h2>Proof of Concept Assembly V002</h2>
                    <p>
                        Built using our E-SPEC software’s design and modeling apps it allowed us to test our internals v002b,
                        with one-piece cranks, three connecting rods per piston, and space for infinitely adjustable valve
                        timing parts integrated with the cranks.
                    </p>{" "}
                </div>
            </SubSection>
            <SubSection>
                <div className="description-container">
                    <h2>Badger Test Engine V001 Full Assembly</h2>
                    <p>
                        Our first ELF-Tech test engine is also the first completely balanced 2-cylinder engine in history
                        (i.e., balancing all primary, secondary, rocking, and rotary forces), and it shows the potential
                        for our high power / weight, low friction, low vibration, low parts, and design family. Designed
                        using our E-SPEC software, early testing showed very high balance, smooth running due to its
                        reduced number of shafts, and low deck height and low overall size for given displacement.
                    </p>{" "}
                    <p>
                        It showcases one of our low-mass, low friction, adjustable timing valve trains, our patented piston
                        stabilization, and our auto balancing internals which give very low friction and high rod ratio
                        benefits in a small package.
                    </p>
                    <p>
                        This unit will soon see extensive vibration, balance, and combustion testing.
                    </p>
                </div>
                <ImageComp imageSource={Badger} width={"Max(25vw, 15rem)"} />
            </SubSection>


            <SecHeader title="ESPEC Comparison Tool" />
            <SubSection>
                <ImageComp imageSource={ESPECSC} width={"Max(25vw, 15rem)"} />
                <div className="description-container">
                    <p>
                        For the very first time users are able to view and interact with a pre-release version of our {" "}
                        <Link to="../user-login"> ESPEC Calculator</Link>.
                        Select desired existing engines that fit your needs or that you want to know more about, see
                        comparison data which can be expanded, then let our design apps offer one or several ELF-Tech
                        design alternatives. The comparison and design tools work together to show options, and then
                        the modeling tools can give simulated and actual performance data, plus specific engine parts
                        and assemblies metrics, and finally, if desired, new ELF-Tech parts from the design and modeling
                        tools can be matched to CADs and blueprints in our library.
                    </p>{" "}
                </div>
            </SubSection>


            <SecHeader title="Contact Us" />
            <SubSection isSplit={false}>
                <div className="description-container">
                    <p>
                        We would like to hear more from you please reach out through our {" "}
                        <Link to="../request-info">Request Info</Link> page. If you have not already done so please create a {" "}
                        <Link to="../user-login">user profile</Link> so we can further
                        assist you in your inquaries.
                    </p>{" "}
                </div>
            </SubSection>
            {/* <PipeDriveEmbed index={0} /> */}
            <SecHeader title="Location" />
            <SubSection isSplit={false}>
                <div className="description-container">
                    <p>
                        Our exhibit is in hall 2 booth 2267 with Pro-Pak APU Systems.

                    </p>{" "}

                </div>
            </SubSection>
            <SecHeader title="More Information" />
            <SubSection isSplit={false}>
                <div className="description-container">
                    <p>
                        Here is some additional information and links about us and the trade show. Please feel free to reach out to us with any questions you may have, and we hope to see you at the event!
                        <ul>
                            <li><Link to="https://www.truckworld.ca/">Truck World</Link></li>
                            <li><Link to="/register">Register</Link></li>
                            <li><Link to="/espec">ESPEC Calculator</Link></li>
                            <li><Link to="/ourStory">About Us</Link></li>
                            <li><Link to="/request-info">Contact Information</Link></li>
                        </ul>
                    </p>{" "}

                </div>
            </SubSection>


        </div>
    );
};

export default TorontoContent;
